import utils from './partidos'
import { requests } from '@/core/api'
import map from '@/core/map'

const isset = val => val !== undefined && val !== null;

export const slugger = (state, local, ano) => {
    if (!state) return;
    const slug = !state ? null : `${state.widget}/${state.tipo}/${ano || state.ano}/${local || state.local}${state.tipo != 'autarquicas' ? '' : `/${state.regiao}`}`;
    return !slug.includes('undefined') ? slug : null
}

export const painter = (state, ficaParaDepois, soDepois) => {
    if (!state || !requests || !state.local || !state.ano) return;
    let colors = {};
    let replaces = {};
    const slug = `${`${slugger(state) || ''}`.replace(state.local, '')}`;
    let total = 0;
    const party = ficaParaDepois && soDepois ? null : false;//TODO -> rever nas freguesias e concelhos
    party && state.resultados && state.resultados.length && state.resultados.forEach(item => {
        if (item.opcao == party) total = parseInt(item.votos || 0);
    });
    let initial = `${state.local}`.slice(0, 2);
    const main = initial.startsWith('5');
    const word = parseInt(`${initial}`.charAt(0));
    if ([3, 4].includes(word)) initial = `${word}`;
    const parse = item => {
        const code = `${item.codigo}`;
        const char = parseInt(`${code}`.charAt(0));
        const votos = parseInt(item.votos || 0);
        if (!party ? (votos && (!colors[code] || (colors[code].votos < votos))) : item.opcao == party) {
            let opacity = !party ? null : ((main && code.endsWith('0000')) || code.startsWith(initial) ? (!total ? .05 : parseFloat(parseFloat(parseFloat(votos / total) * .65) + .35)) : .05);
            if (party && isNaN(opacity)) opacity = .05;
            colors[code] = {
                key: item.opcao,
                fill: party && !votos ? null : utils.cores[utils.partify(item.opcao)],
                votos,
                opacity
            };
        }
        if ([3, 4].includes(char) && state.local == '500000' && map.codes[code] && map.codes[code].children) for (let key in map.codes[code].children) replaces[key] = code;
    }
    for (let key in requests) if (key.startsWith(slug) && requests[key].r) {
        requests[key].r.resultados && requests[key].r.resultados.length && requests[key].r.resultados.forEach(parse);
        requests[key].r.children && requests[key].r.children.length && requests[key].r.children.forEach(item => (item && item.resultados && item.resultados.length && item.resultados.forEach(parse)));
    }
    for (let name in replaces) if (colors[replaces[name]]) colors[name] = {
        ...colors[replaces[name]]
    };
    return colors;
}

export const status = (state, local, ano) => {
    if (!state || !requests || !local) return;
    const main = `${local}`.replace('990000', '500000');
    const slug = `${(!ano ? main : main.replace(state.ano, ano)).slice(0, -2)}00`;
    if (main && requests[main]) return !requests[main].a ? (!requests[main].r ? 'error' : 'ready') : 'loading';
    const parent = `${slug}`;
    return !parent || !requests[parent] ? null : (!requests[parent].a ? (!requests[parent].r ? 'error' : 'ready') : 'loading');
}

export const data = (state, local, ano) => {
    if (!state || !requests || !local) return;
    const main = `${local}`;
    const slug = `${(!ano ? main : main.replace(state.ano, ano)).slice(0, -2)}00`;
    if (!requests) return;
    let res = !main || !requests[main] ? null : requests[main].r;
    if (!res) {
        const parent = `${slug}`;
        parent && requests[parent] && requests[parent].r && requests[parent].r.children && requests[parent].r.children.length && requests[parent].r.children.forEach(child => {
            if (child.codigo == state.local) res = child;
        })
    }
    return res;
}

export const global = (state, local) => {
    if (!state || !requests || !local) return;
    const nacionalSlug = `${local.replace(state.local, '500000')}`;
    let nacional = !nacionalSlug || !requests[nacionalSlug] ? null : requests[nacionalSlug].r
    if (!nacional) return;
    const estrangeiroSlug = `${local.replace(state.local, '600000')}`;
    let estrangeiro = !estrangeiroSlug || !requests[estrangeiroSlug] ? null : requests[estrangeiroSlug].r;
    if (!estrangeiro) return;
    let res = {
        nome_do_territorio: 'Global',
        resultados: [],
        updated_at: nacional.updated_at || estrangeiro.updated_at
    },
        resultados = {
            nacional: {},
            estrangeiro: {}
        }
    nacional.resultados.forEach(item => {
        const opcao = item.opcao != 'PCP-PEV' ? item.opcao : 'CDU';
        resultados.nacional[opcao] = {
            ...item,
            opcao
        }
    });
    estrangeiro.resultados.forEach(item => {
        const opcao = item.opcao != 'PCP-PEV' ? item.opcao : 'CDU';
        resultados.estrangeiro[opcao] = {
            ...item,
            opcao
        }
    });

    parseInt(state.ano) >= 2024 && state.tipo != 'autarquicas' && ['nacional', 'estrangeiro'].forEach(val => {
        ['PPD/PSD.CDS-PP', 'PPD/PSD.CDS-PP.PPM'].forEach(part => {
            if (!resultados[val].AD) resultados[val].AD = {
                opcao: 'AD',
                //note: 'AD é uma coligação entre PPD, PSD, CDS e PPM em todos os círculos eleitorais, exceto na Madeira (que não inclui PPM).'
            };
            if (!resultados[val][part]) return;
            ['mandatos', 'votos', 'percent_votantes'].forEach(prop => {
                if (!resultados[val].AD[prop]) resultados[val].AD[prop] = 0;
                resultados[val].AD[prop] += parseFloat(resultados[val][part][prop]);
            });
            delete resultados[val][part];
        });
    });
    ['brancos', 'inscritos', 'nulos', 'mandatos', 'mandatos_por_atribuir',
        'total_de_concelhos', 'total_de_freguesias',
        'concelhos_apurados', 'concelhos_por_apurar', 'freguesias_apuradas', 'freguesias_por_apurar',
        'consulados apurados', 'consulados por apurar', 'total de consulados',
        'consulados_apurados', 'consulados_por_apurar', 'total_de_consulados'

    ].forEach(item => {
        res[item] = parseFloat(nacional[item] || 0) + parseFloat(estrangeiro[item] || 0);
    });
    res.votos = res.votantes = parseFloat(nacional.votos || nacional.votantes || 0) + parseFloat(estrangeiro.votos || estrangeiro.votantes || 0);
    for (let key in resultados.nacional) {
        let item = {
            ...resultados.nacional[key],
            votos: parseFloat(!resultados.nacional[key] ? 0 : (resultados.nacional[key].votos || resultados.nacional[key].votantes || 0)) + parseFloat(!resultados.estrangeiro[key] ? 0 : (resultados.estrangeiro[key].votos || resultados.estrangeiro[key].votantes || 0)),
            mandatos: parseFloat(!resultados.nacional[key] ? 0 : (resultados.nacional[key].mandatos || 0)) + parseFloat(!resultados.estrangeiro[key] ? 0 : (resultados.estrangeiro[key].mandatos || 0))
        };
        item.percent_votantes = !item.votos || !res.votos ? 0 : (item.votos * 100 / res.votos);
        res.resultados.push(item);
    }
    /* ['percent_brancos', 'percent_nulos', 'percent_votantes'].forEach(item => {
        if (isset(nacional[item]) && isset(estrangeiro[item])) res[item] = parseFloat(nacional[item] || 0) + parseFloat(estrangeiro[item] || 0);
    }); */
    if (!isset(res.percent_brancos)) res.percent_brancos = res.brancos * 100 / res.votos;
    if (!isset(res.percent_nulos)) res.percent_nulos = res.nulos * 100 / res.votos;
    if (!isset(res.percent_votantes)) res.percent_votantes = res.percent_votos = res.votos * 100 / res.inscritos;
    return res;
}

export default {
    ...utils,
    slugger,
    painter,
    status,
    data,
    global
}